
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/catradio/programacio/[slug]",
      function () {
        return require("private-next-pages/corporatiu/catradio/programacio/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/catradio/programacio/[slug]"])
      });
    }
  